module.exports = __webpack_public_path__ + "static/media/flonne.ceeaf3f6.png";